/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DisconnectedUsageStateEnum } from './disconnectedUsageStateEnum';
import { OperationOriginEnum } from './operationOriginEnum';


export interface DisconnectedUsageResponse { 
    /**
     * Disconnected SRM pair UUID
     */
    entity_uuid: string;
    expiry_ts: Date;
    org_id: string;
    quantity: number;
    state: DisconnectedUsageStateEnum;
    created_ts: Date;
    created_by?: OperationOriginEnum;
    id?: number;
    updated_by?: OperationOriginEnum;
    updated_ts?: Date;
}
export namespace DisconnectedUsageResponse {
}


